import { forwardRef } from "react";
import { useTheme } from "@mui/material/styles";
import { Chip } from "@mui/material";

const defaultColors = ["info", "success", "warning", "error"];
const CustomChip = forwardRef(({ trailingIcon, trailingFn, ...props }, ref) => {
  const theme = useTheme();
  const { color, sx = {}, ...rest } = props;

  const chipSX = {
    minHeight: 28,
    padding: "0 6px",
    ...sx,
  };
  const map = {
    info: {
      ...chipSX,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
    success: {
      ...chipSX,
      color: theme.palette.success.dark,
      backgroundColor: theme.palette.success.light,
    },
    warning: {
      ...chipSX,
      color: "black",
      backgroundColor: theme.palette.warning.semiDark,
    },
    error: {
      ...chipSX,
      color: theme.palette.orange.dark,
      backgroundColor: theme.palette.orange.light,
      marginRight: "5px",
    },
    teal: {
      ...chipSX,
      color: "white",
      backgroundColor: theme.palette.teal.main,
    },
    pink: {
      ...chipSX,
      color: "white",
      backgroundColor: theme.palette.pink.main,
    },
    orange: {
      ...chipSX,
      color: "white",
      backgroundColor: theme.palette.orange.main,
    },
  };

  if (color && !defaultColors.includes(color)) {
    sx.color = "white";
    sx.backgroundColor = color;
  } else {
    rest.color = color;
  }

  return (
    <Chip
      ref={ref}
      {...rest}
      sx={color && map[color] ? map[color] : sx}
      deleteIcon={trailingIcon}
      onDelete={trailingFn ? trailingFn : trailingIcon ? () => {} : null}
    />
  );
});

export default CustomChip;
